import React, { useState } from "react";
import {
  ListItemIcon,
  ListItem,
  ListItemText,
  List,
  SwipeableDrawer,
  Button,
  Avatar,
  IconButton,
} from "@material-ui/core/";

import {
  BarChart,
  LocalShipping,
  Store,
  DragIndicator,
  Backspace,
  PhotoCamera,
  Check,
  RateReview,
  Report,
  History,
} from "@material-ui/icons/";

import { logout, uploadDp } from "../../actions/authActions";
import { connect } from "react-redux";

import Modal from "../ConfirmationModal";

const Drawer = (props) => {
  const [open, setOpen] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [imageURL, setImageURL] = useState(props.auth.seller.image);
  const [image, setImage] = useState("");

  function closeModal() {
    setOpen(false);
    setConfirmationModal(false);
  }

  const uploadImage = () => {
    const imageFile = new FormData();
    imageFile.append("image", image);
    props.uploadDp(props.auth.seller._id, imageFile);
    setImage("");
    closeModal();
  };

  return (
    <div>
      <Button onClick={() => setOpen(true)} style={{ color: "white" }}>
        <DragIndicator />
      </Button>
      {confirmationModal ? (
        <Modal
          open={confirmationModal}
          handleClose={() => closeModal()}
          message={"Are you sure to logout?"}
          onConfirm={() => {
            props.logout();
            props.history.push("/");
          }}
        />
      ) : (
        <SwipeableDrawer
          anchor="right"
          open={open}
          onClose={() => setOpen(false)}
        >
          <List style={{ width: "200px" }}>
            <ListItem key="User">
              <div
                style={{
                  margin: "40px auto 0 auto",
                }}
              >
                <Avatar
                  alt="Profile Image"
                  src={imageURL ? imageURL : props.auth.seller.name}
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "contain",
                  }}
                />
              </div>
              <div style={{ marginTop: "auto" }}>
                {image === "" ? (
                  <div>
                    <input
                      accept="image/*"
                      id="icon-button-file"
                      type="file"
                      className="form-input"
                      onChange={(e) => {
                        setImage(e.target.files[0]);
                        setImageURL(URL.createObjectURL(e.target.files[0]));
                      }}
                      style={{ display: "none", objectFit: "contain" }}
                    />
                    <label htmlFor="icon-button-file">
                      <IconButton
                        color="primary"
                        aria-label="upload picture"
                        component="span"
                      >
                        <PhotoCamera />
                      </IconButton>
                    </label>
                  </div>
                ) : (
                  <IconButton onClick={() => uploadImage()}>
                    <Check color="primary" />
                  </IconButton>
                )}
              </div>
            </ListItem>

            <hr />

            <ListItem
              button
              key="Sales Chart"
              onClick={() => {
                setOpen(false);
                props.history.push(`/sales/chart/${props.auth.seller._id}`);
              }}
            >
              <ListItemIcon>
                <BarChart />
              </ListItemIcon>
              <ListItemText primary="Sales Chart" />
            </ListItem>

            <ListItem
              button
              key="Delivery Boy"
              onClick={() => {
                setOpen(false);
                props.history.push("/deliveryboy");
              }}
            >
              <ListItemIcon>
                <LocalShipping />
              </ListItemIcon>
              <ListItemText primary="Delivery Boy" />
            </ListItem>

            <ListItem
              button
              key="Manage_Store"
              onClick={() => {
                setOpen(false);
                props.history.push(`/shop/management/${props.auth.seller._id}`);
              }}
            >
              <ListItemIcon>
                <Store />
              </ListItemIcon>
              <ListItemText primary="Manage Store" />
            </ListItem>

            <ListItem
              button
              key="complaints"
              onClick={() => {
                setOpen(false);
                props.history.push(`/shop/complaints/${props.auth.seller._id}`);
              }}
            >
              <ListItemIcon>
                <Report />
              </ListItemIcon>
              <ListItemText primary="Complaints" />
            </ListItem>

            <ListItem
              button
              key="reviews"
              onClick={() => {
                setOpen(false);
                props.history.push(`/shop/reviews/${props.auth.seller._id}`);
              }}
            >
              <ListItemIcon>
                <RateReview />
              </ListItemIcon>
              <ListItemText primary="Reviews" />
            </ListItem>

            <ListItem
              button
              key="history"
              onClick={() => {
                setOpen(false);
                props.history.push(`/shop/history/${props.auth.seller._id}`);
              }}
            >
              <ListItemIcon>
                <History />
              </ListItemIcon>
              <ListItemText primary="History" />
            </ListItem>

            <ListItem
              button
              key="logout"
              onClick={() => setConfirmationModal(true)}
            >
              <ListItemIcon>
                <Backspace />
              </ListItemIcon>
              <ListItemText primary="Logout" />
            </ListItem>
          </List>
        </SwipeableDrawer>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  order: state.server.order,
});

export default connect(mapStateToProps, { logout, uploadDp })(Drawer);
